export default {
    welcome: 'Welcome to the site!',
    message: 'This is a message in English.',
    application:'application',
    language: 'Language',
    heroEyebrow: 'Application · Online form',
    heroTitle: 'Your place for the coming semester starts here',
    heroDescription: 'Complete the information below to register for your courses. Everything is available on this one page.',
    // Sections
    personalInformation: 'Personal Information',
    personalInformationDescription: 'Your contact and address details for the application.',
    degreeEducation: 'Degree / Education',
    theologicalEducation: 'Theological Education(if available; voluntary information)',
    spouse: 'Spouse',
    studyForm: 'Study Form',
    studyFormDescription: 'Choose the form of study that suits you.',
    participationType: 'Type of Participation',
    moduleSelection: 'Module Selection',

    documents: 'Documents (allowed files: .pdf .jpg .jpeg .png .doc .docx)',
    Certificates: 'Certificates (high school diploma, bachelor’s degree, etc.)',
    furtherQuestion: 'Further Questions',
    consentNewsletter: 'Consent & Newsletter',
    Courses:'Courses',
    otherCourses:'Other Courses',
    coursesFromOtherTerms:'Courses from other terms',
    courseLimitDescription: 'Current-semester courses. You can select a maximum of {max} courses in total.',
    courseLimitReached: 'You have reached the maximum of {max} courses. Remove one course before selecting another.',
    coursesSelected: '{count} selected',
    noCoursesSelected: 'none selected',
    semester: 'Semester',

    // Personal Information
    sex: 'sex',
    firstName: 'First Name',
    lastName: 'Last Name',
    street: 'Street',
    houseNumber: 'House Number',
    postalCode: 'Postal Code',
    city: 'City',
    phoneNumber: 'Phone Number',
    email: 'Email',
    dateOfBirth: 'Date of Birth',
    placeOfBirth: 'Place of Birth',
    maritalStatus: 'Marital Status',
    nationality: 'Nationality',
    denomination: 'Denomination',
    fathersFirstName: "Father's First Name",
    fathersLastName: "Father's Last Name",
    fathersNationality: "Father's Nationality",

    // Degree / Education
    diploma: 'Diploma / Degree',
    specialization: 'Specialization',
    placeOfTraining: 'Place of Training',
    graduationYear: 'Year of Graduation',
    thesisGrade: 'Grade of Thesis',

    // Theological Education
    institution: 'Institution',
    level: 'Level',
    theologyGraduationYear: 'Graduation Year (Theology)',
    additionalTraining: 'Additional Training',
    NameOfTheSchool:'Name of the school',
    DurationOfTraining:'Duration of training',

    // Spouse
    spouseTitle: 'Spouse Title',
    spouseFirstName: 'Spouse First Name',
    spouseLastName: 'Spouse Last Name',
    spouseNationality: 'Spouse Nationality',
    spouseDenomination: 'Spouse Denomination',
    spouseProfession: 'Spouse Profession',

    // Study Form
    fullTime: 'Full-Time',
    fullTimeDescription: 'Full course program with regular attendance.',
    partTime: 'Part-Time',
    partTimeDescription: 'Reduced course load alongside work or other studies.',
    guestStudentStatus: 'Guest Student Status',
    guestStudentStatusDescription: 'Open participation, with or without examinations and a certificate of participation.',
    GuestStudentshipWithCertificate:'Guest studentship with certificate',
    GuestStudentStatusWithoutCertificate:'Guest student status without certificate',
    distanceLearning: 'distanceLearning',
    block: 'Block',
    intensiveCourse: 'Intensive Course',

    // Participation Type
    online: 'Online',
    offline: 'Offline',

    // Module Selection
    foundationsOfBelief3: "Foundations of Belief III",
    wordsOfQuranAndRoots3: "The Words of the Quran and Their Roots III",
    logic2: "Logic (mantiq) II",
    islamicLegalProvisions3: "Islamic Legal Provisions in Everyday Practice III",
    introQuranicStudies: "Introduction to Quranic Studies",
    recitationIntonationQuran1: "Recitation and Intonation of the Quran I",
    introIslamicLegalNorms: "Introduction to the Foundations of Understanding Islamic Legal Norms",

    // Documents
    Passport: 'Copy of passport or identity card',
    certificate: 'Certificate',
    photo: 'Photo',
    cv: 'Lebenslauf',

    // Further Questions
    messageOrQuestion: 'Your message or question...',

     copyOfPassportOrId: "Copy of passport or identity card",
    biometricPhoto: "Biometric Foto",
    furtherQuestions: "Do you have any further questions for us?",
    consentAndNewsletter: "Consent & Newsletter",

    // Consent & Newsletter
    consent: 'I consent to my data being stored for processing my request.',
    newsletter: 'I would like to subscribe to the Al-Mustafa newsletter.',
    submit: 'Submit application',

    // Validation
    pleaseFill: 'Please fill in this field.',
    ChooseFile:'Choose File',
    PleaseSelectOne:'Please select at least one course',
    passport_required: "Please upload your passport.",
    certificate_required: "Please upload your certificate.",
    photo_required: "Please upload your biometric photo.",
    cv_required: "Please upload your CV file.",
    agreeInfoStorage: 'I agree that the information I submit will be stored so that my request can be answered',
    course: 'Course',
    studentInitialPayment: 'You are a student. Initial payment: €450 was applied',
    regularPrice: 'Regular price (non-student)',
    mode: 'Mode',
    duration: 'Duration',
    paymentType: 'Payment Type',
    paymentTypeDescription: 'Choose your payment model. Your total will never exceed the applicable price cap.',
    yourPrice: 'Your price',
    priceForCourses: 'for {count} selected course(s)',
    individualPriceTotal: 'Individual prices total',
    packageSaving: 'Package price: you save {amount}',
    priceCapNote: 'The sum of your course prices. You will never pay more than {cap} — from this amount onward, the package price applies.',
    basePrice: 'Base Price',
    paymentOffline: 'Payment Offline',
    // paypalInstruction: 'Please transfer the payment to the following PayPal account:',
    paypalInstruction: 'Please transfer the payment to the following account:',
    payNow: 'Pay Now',
    agreeAndPay: 'Agree and pay',
    cancel: 'Cancel',
    closes: 'Closes',
    price: 'Price',
    action: 'Action',
     installment: 'Installment',
     selectCoursesToAdd: 'Select courses to add',
    courseName: 'Course Name',
    orderSummaryPayment: 'Order Summary & Payment',
    yourMessageOrQuestion: 'Your message or question...',
    areYouAStudent: 'Are you studying in Al Mustafa?',
    yes: 'Yes',
    no: 'No',
    onlineTotal: 'Online total:',
    offlineTotal: 'Offline total:',
    grandTotal: 'Grand total:',
    paymentSuccessful: 'Payment Successful',
    paymentFailed: 'Payment Failed',
    amount: 'Amount',
     referenceId: 'Reference ID',
    description: 'Description',
    something_went_wrong:'something went wrong',
    file_too_large:'The file {name} is larger than 2 MB.',
    request_too_large:'The uploaded file is too large. Each file must be no larger than 2 MB.',
    session_expired:'Your session expired. Please submit the form again.',
    invalidEmail:'Invalid email address',
    Nameoftheschool:"Name of the school",
    title: "Title",
    Mister:"Mister",
    Woman: "Woman",
    SelectPlaceHolder:"Select...",
    PleaseInput: "Please input",
    SelectDate:"Select Date",
    Delete:"Delete",
    "part-time": 'part-time',
    "full-time": 'full-time',
    courseType:"courses types is {type}",
    paymentTypeis:"payment course type is {type}",
    Unique:'Unique',
    directDebit:'SEPA Direct Debit Mandate',
    accountHolder:'Account holder',
    directDebitMandate:'I authorize Veranstaltung gGmbH to collect payments from my account by direct debit. At the same time, I instruct my bank to honor the direct debits drawn by Veranstaltung gGmbH on my account.',
    noticeDebit:'Note: I can request a refund of the debited amount within eight weeks of the debit date. The terms and conditions agreed upon with my bank apply.',
    agreeDebit:'I agree to the terms and conditions.',
    emailwassuccessfullysent:"email was successfully sent ✅",
    emailwasnotsent:"email was not sent ❌",
    Online:"Online"

    ,
    // reCAPTCHA
    recaptcha_failed_to_load: 'Captcha failed to load. Please refresh the page.',
    recaptcha_placeholder_not_found: 'Captcha placeholder not found.',
    recaptcha_placeholder_not_found_in_time: 'Captcha placeholder not found in time.',
    recaptcha_please_check: 'Please check “Im not a robot”.',
    recaptcha_failed_render_modal: 'Failed to render modal reCAPTCHA.',
    recaptcha_please_complete: 'Please complete the captcha.',
    recaptcha_verification_failed: 'The captcha has expired or was already used. Please complete it again.'


}
